import { render, staticRenderFns } from "./EditProductsSector.vue?vue&type=template&id=8ee60432&scoped=true&"
import script from "./EditProductsSector.vue?vue&type=script&lang=js&"
export * from "./EditProductsSector.vue?vue&type=script&lang=js&"
import style0 from "./EditProductsSector.vue?vue&type=style&index=0&id=8ee60432&scoped=true&lang=css&"
import style1 from "./EditProductsSector.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee60432",
  null
  
)

export default component.exports